function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0,0H24V24H0Z",
  "data-name": "Path 3692"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f1f1f1",
  d: "M1.8,1.329a.9.9,0,0,0-1.273,0h0a.9.9,0,0,0,0,1.273l2.8,2.8H1.811a1.8,1.8,0,0,0-1.8,1.8V12a1.8,1.8,0,0,0,1.8,1.8h3.44l3.5,4.681a1.744,1.744,0,0,0,1.417.722,1.786,1.786,0,0,0,1.81-1.8V14.059l4.877,4.877a.9.9,0,0,0,1.273-1.273ZM10.18,17.381,6.692,12.719,6.152,12H1.812V7.2H5.123l5.057,5.057Zm4.7-5.515L13.808,10.8V7.354a.481.481,0,0,1,.851-.3,3.886,3.886,0,0,1,.215,4.816ZM13.9,3.525a.9.9,0,0,1,1.2-.427,7.179,7.179,0,0,1,2.288,11.275L16.11,13.1a5.385,5.385,0,0,0-1.788-8.377A.9.9,0,0,1,13.9,3.525ZM7.89,4.88,6.6,3.594,8.753.722A1.744,1.744,0,0,1,10.17,0a1.786,1.786,0,0,1,1.81,1.8V8.971l-1.8-1.8V1.819Z",
  "data-name": "Path 3612",
  transform: "translate(2.388 2.4)"
});

function SvgSpeakerMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "data-name": "Speaker Mute",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerMuted);
export default __webpack_public_path__ + "static/media/speaker_muted.048158d7.svg";
export { ForwardRef as ReactComponent };